import { nanoid } from "nanoid";
import { useFieldArray } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { useEffect } from "react";
import { PlusIcon } from "../../../icons/PlusIcon";
import { BuilderList } from '../../FormGeneratorTypes';

type InputListProps = {
  theme: any;
  register: any;
  control: any;
  required: boolean;
  errors: any;
  builder: BuilderList;
  name: string;
};

const ListInputs = ({
  theme,
  register,
  control,
  required,
  errors,
  builder,
  name,
}: InputListProps) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const handleAddInput = () => {
    const inputList = [
      {
        id: nanoid(),
        valueA: "",
        valueB: "",
      },
    ];
    inputList.forEach((input) => {
      append(input);
    });
  };

  useEffect(() => {
    if (builder?.inputList) {
      append(builder.inputList);
    }
  }, [builder?.inputList, append]);

  const styles = {
    flex: {
      display: "flex",
      gap: "10px",
      marginBottom: "10px",
      width: "100%",
    },
    input: {
      border: 0,
      borderRadius: 0,
      boxShadow: "none",
      margin: "0 auto",
      outline: "none",
      padding: `${theme?.to_rem("16px")} 0`,
      transition: "0.3s",
      width: "100%",
      borderBottom: `1px solid ${theme?.colors?.border_color}`,
      marginTop: "10px",
    },
    delete: {
      outline: "none",
      border: "none",
      padding: 0,
      background: "transparent",
      cursor: "pointer",
      fontWeight: 700,
    },
    add: {
      display: "flex",
      alignItems: "center",
      outline: "none",
      border: "none",
      padding: 0,
      background: "transparent",
      cursor: "pointer",
      fontWeight: 700,
    },
  };

  return (
    <>
      {fields?.map((field, index) => (
        <div
          key={field.id}
          style={styles?.flex}
        >
          <div style={{ width: "100%" }}>
            <input
              type="text"
              {...register(`[${name}][${index}].valueA`, {
                required: required ? `${builder?.field1} is required` : false,
              })}
              style={styles?.input}
              placeholder={builder?.field1}
            />
            <ErrorMessage
              errors={errors}
              name={`[${name}][${index}].valueA`}
              as="span"
              className="error-form"
            />
          </div>

          <div style={{ width: "100%" }}>
            <input
              type="text"
              {...register(`[${name}][${index}].valueB`, {
                required: required ? `${builder?.field2} is required` : false,
              })}
              style={styles?.input}
              placeholder={builder?.field2}
            />
            <ErrorMessage
              errors={errors}
              name={`[${name}][${index}].valueB`}
              as="span"
              className="error-form"
            />
          </div>

          <button
            type="button"
            onClick={() => {
              remove(index);
            }}
            disabled={fields.length === 1}
            style={styles?.delete}
          >
            -
          </button>
        </div>
      ))}
      <button
        type="button"
        onClick={handleAddInput}
        style={styles?.add}
      >
        <PlusIcon style={{ width: "8px", height: "8px" }} />
        Add Field
      </button>
    </>
  );
};

export default ListInputs;
